import { Button } from '@1trading/react';
import { Link } from 'react-router-dom';

export const NotFoundPage = () => (
  <main className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-background text-foreground">
    <h1 className="font-semibold text-2xl">Page not found</h1>
    <p className="text-muted-foreground text-sm">This page doesn't exist. Head back to the launcher.</p>
    <Button asChild>
      <Link to="/">Back to dashboard</Link>
    </Button>
  </main>
);
